import { flattenError, type ZodSafeParseResult } from 'zod';

export type ValidationState<T> = {
  isValid: boolean;
  fieldErrors: ReturnType<typeof flattenError<T>>['fieldErrors'];
};

export const VALID_VALIDATION_STATE = {
  isValid: true,
  fieldErrors: {},
};

export const createValidationState = <T>(result: ZodSafeParseResult<T>): ValidationState<T> => {
  if (result.success) return VALID_VALIDATION_STATE;

  return {
    isValid: false,
    fieldErrors: flattenError(result.error).fieldErrors,
  };
};
